export default __webpack_public_path__ + "static/mainProject-f64de7be68c847b739901b9dbc0ba3af.png";